<script>
export default {
    template: " ",
    mounted() {
        window.Echo.private('element_keys.' + this.elementKeyUUID)
            .listen('.measure.saved', (data) => {
                //console.log('websocket -> MEASURE SAVED from ElementKeys: ' + data.measure, data);

                this.$store.commit('addMeasure', data.measure);
            });

        window.Echo.private('projects.' + this.projectUUID)
            .listen('.client-measure.saved', (data) => { //TODO: DRY

                if (data.measure.uuid === this.elementKeyUUID) {
                    //console.log('websocket -> CLIENT MEASURE SAVED from Project: ' + data.measure, data);

                    let element_key_real_time_value = document.getElementById("element_key_real_time_value");
                    if (data.measure.value_type === 'decimal') {
                        element_key_real_time_value.innerHTML = data.measure.value_key.toFixed(4);
                    }
                    else {
                        element_key_real_time_value.innerHTML = data.measure.value_key;
                    }
                    element_key_real_time_value.classList.add("bg-red");
                    setTimeout(function() { element_key_real_time_value.classList.remove("bg-red"); }, 2000);
                }
            });

        console.log('PRIVATE: projects.' + this.projectUUID);
        console.log('PRIVATE: element_keys.' + this.elementKeyUUID);

    },
    data() {
        return {
            'projectUUID': this.getProjectUUID(),
            'elementKeyUUID': this.getElementKeyUUID()
        }
    },
    methods: {
        getProjectUUID() {
            //TODO: DRY
            let projectUUID = document.head.querySelector('meta[name="meta-projectUUID"]');

            if (projectUUID) {
                return projectUUID.content;
            } else {
                console.error('projectUUID meta not found.');
            }
        },
        getElementKeyUUID() {
            //TODO: DRY
            let elementKeyUUID = document.head.querySelector('meta[name="meta-elementKeyUUID"]');

            if (elementKeyUUID) {
                return elementKeyUUID.content;
            }
            else {
                console.error('elementKeyUUID meta not found.');
            }
        }
    }
}
</script>
